import React, { Component } from "react";
import {
  company,
  profile,
  GET,
  POST,
  alert,
  loading,
  t
} from "./CustomComponent.js";
import Language from "../components/Language.js";
import { Navbar, Nav } from "react-bootstrap";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total_balance_available: 0,
      total_balance_thb: 0,
      total_balance_lak: 0,
      dropdown: "",
      array_link: [...this.filterMenu(profile)],
      user_profile: profile,
      modal_news: false,
      announce_datetime: "",
      announce_duration: 0,
      announce_detail: "",

    };
  }

  icon = (io) => <span className="icon">{io}</span>;

  componentDidMount = async () => {
    // โหลดโปรไฟล์
    await this.GetProfile();

    // ตรวจสอบการล็อกอิน
    if (!profile) {
      window.location.href = "/";
      return;
    }
  };
  GetProfile = async () => {
    const result = await GET("admin/users/profile", null, false);
    if (result?.status) {
      localStorage.setItem("cm-profile", JSON.stringify(result.data));
      this.setState({
        user_profile: result.data,
        array_link: [...this.filterMenu(result.data)],
      });
      this.permissionSetting();
    }
  };
  async componentDidUpdate() {
    const active = document.querySelector(".active");
    if (active) {
      active.focus();
      active.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    this.permissionSetting();
  }
  filterMenu = (profile) => {
    let perms = profile?.role?.permission || [];

    // perms.push("settings.read");
    const menu = global.menu_admin?.filter(
      (item) =>
        !item.link ||
        !item.permission ||
        perms.includes(item.permission),
    );
    return menu
      .reduce((acc, item) => {
        if (item.title && acc.at(-1)?.title) return acc;
        acc.push(item);
        return acc;
      }, [])
      .filter((_, i, arr) => !(i === arr.length - 1 && arr[i].title));
  };
  permissionSetting = () => {
    const role = new Set(this.state.user_profile?.role?.permission || []);
    global.permission.forEach((perm) => {
      if (!role.has(perm)) {
        [...document.getElementsByClassName(perm)].forEach((el) => el.remove());
      }
    });
  };
  componentMenu = () => {
    const classNameBTN =
      "nav-link-sidebar d-flex align-items-center py-2 px-3 mb-1 rounded-lg text-decoration-none";
    const classNameICON = "icon wpx-24 text-center me-3";
    const currentPath = `/${window.location.href.split("/").pop()}`;
    const linkItem = (href, icon, label, isActive, extra = null) => (
      <a
        href={href}
        className={`${classNameBTN} ${isActive ? "active" : ""}`}
      >
        <span className={classNameICON}>
          {icon}
        </span>
        <span className="flex-grow-1">{t(label)}</span>
        {extra}
        {}
      </a>
    );

    const { array_link, user_profile } = this.state;

    return (
      <div className="sidebar-menu">
        {array_link.map((item, i) => {
          if (!item.title && !item.link){
            return null;
          }
          if (item.title)
            return (
              <div className="sidebar-section-title text-uppercase text-secondary small fw-semibold px-3 py-2 mt-1 mb-1" key={`title-${i}`}>
                {t(item.title)}
              </div>
            );
          const params = [`type=${item.type}`]?.filter(Boolean).join("&");
          const href = `${item.link}${
            item.type || item.country ? "?" + params : ""
          }`;
          const isActive = href === currentPath;
          return linkItem(
            `${href}`,
            item.icon,
            item.name,
            isActive,
            item.component,
          );
        })}

        {/* <hr className="my-3 mx-3 sidebar-divider" /> */}

        <div className="d-block d-xl-none px-2">
          <button
            className={`${classNameBTN} w-100 text-danger border-0 bg-transparent`}
            onClick={async () => {
              this.Logout();
            }}
          >
            <span className={classNameICON}>
              {"\uf2f5"}
            </span>
            <span>{["super_user","admin-company"].includes(user_profile?.user_type) ? t("back_to_portal") : t("logout")}</span>
          </button>
        </div>
        <div className="d-none d-xl-block hpx-100"></div>
      </div>
    );
  };
  Logout = async () => {
    const {user_profile} = this.state;
    if(["super_user","admin-company"].includes(user_profile?.user_type)){
      window.location.href = "/portal";
    }else{
      let module = [];

    if((user_profile.role?.permission).includes("dashboard-admin.read")){
        module.push("admin");
    }
    if((user_profile.role?.permission).includes("dashboard-customer.read")){
        module.push("customer");
    }
    if((user_profile.role?.permission).includes("dashboard-warehouse.read")){
        module.push("warehouse");
    }
    if(module.length >1){
      window.location.href = "/portal";
    }
    if (
       await alert(
              "",
              "warning",
              t("confirm"),
              t("logout_ask"),
              t("logout"),
              t("cancel"),
            )
    ) {
      loading(true);
      let result = await POST("auth/logout", null);
      if (result?.status) {
        localStorage.clear();
        window.location.href = "/";
      }
      loading(false);
    }
    }
  };

  render() {
    const {
      user_profile,
    } = this.state;
    return (
      <div className="hpx-50">
        <Navbar
          className="px-3 px-xl-4 bg-white position-fixed w-100"
          style={{ zIndex: 1020, border: "0", borderBottom: "1px solid var(--bs-gray-2)" }}
          expand="xl"
        >
          <Navbar.Brand href={`/ad/dashboard`} className="fw-bold text-dark d-flex">
            <div className="position-relative">
              <img
                alt="logo"
                src={LOGO}
                height={25}
                style={{ objectFit: "contain" }}
                className="pointer d-none d-sm-block"
                onClick={() => {
                  window.location.href = `/ad/dashboard`;
                }}
              />
              <img
                alt="logo"
                src={LOGO}
                height={30}
                style={{ objectFit: "contain" }}
                className="pointer d-block d-sm-none"
                onClick={() => {
                  window.location.href = `/ad/dashboard`;
                }}
              />
              <span className="position-absolute d-none d-sm-block" style={{ right: 8, bottom: -4, fontSize: 10, color: "#dabb55" }}>
                {user_profile?.user_type?.replaceAll("_", "")} v{" "}
                {global.version}
              </span>
            </div>
          </Navbar.Brand>
          <div className="d-flex">
            <Navbar.Toggle className="border-0" aria-controls="basic-navbar-nav"/>
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <div className="d-none d-xl-flex align-items-center">
                 <Language/>
                <div className="hpx-40 mx-3" style={{ width: 1, backgroundColor: 'var(--bs-gray-2)' }}/>
                <div className="d-none d-xl-flex align-items-center text-start user-badge px-2 py-1 rounded-lg">
                  <span className="user-avatar me-2 wpx-32 hpx-32 d-flex align-items-center justify-content-center" style={{ fontSize: '0.75rem' }}>
                    {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
                  </span>
                  <div className="pe-2">
                    <div className="text-14 fw-semibold text-dark">
                      {user_profile?.full_name || "Username"}
                    </div>
                    <div className="text-12 text-secondary" style={{ marginTop: -2 }}>
                      {user_profile?.role?.name || user_profile?.user_type?.replaceAll("_", " ") || "User"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-block d-xl-none mb-5 pt-4 overflow-scroll" style={{ height: "80vh" }}>
                {this.componentMenu()}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div
          className="position-fixed wpx-260 sidebar-dark overflow-scroll d-none d-xl-block"
          style={{
            zIndex: 1021,
            height: "100vh",
            border: "0",
          }}
        >
          <div
            className="d-flex pt-3 position-fixed sidebar-dark pb-3 px-3 wpx-260 sidebar-brand"
            style={{
              border: "0",
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <span className="text-20 icon text-white">{"\uf494"}</span>
              <span className="text-20 text-white fw-bold">{company?.name || "-"}</span>
              {/* version */}
              <div className="mt-2">
                <small className="position-absolute text-11 text-secondary" style={{ top: 38, left: 47 }}>version {global.version}</small>
              </div>
            </div>
          </div>
          <div className="px-3 mb-5" style={{ marginTop: 60 }}>
            {this.componentMenu()}
          </div>
          <div
            className="position-fixed sidebar-dark pb-3 px-3 wpx-260"
            style={{
              bottom: 0,
              border: "0",
              borderTop: "1px solid #334155",
              paddingTop: "12px",
            }}
          >
            <div className="d-flex align-items-center text-start w-100 p-2 rounded-lg" style={{ backgroundColor: '#334155' }}>
              <span className="user-avatar me-2 wpx-36 hpx-35 d-flex align-items-center justify-content-center" style={{ fontSize: '0.8rem' }}>
                {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
              </span>
              <div className="flex-grow-1 overflow-hidden">
                <div className="text-14 fw-semibold text-white text-truncate">
                  {user_profile?.full_name || "Username"}
                </div>
                <div className="text-12 text-truncate" style={{ marginTop: -2, color: '#94a3b8' }}>
                  {user_profile?.role?.name || user_profile?.user_type?.replaceAll("_", " ") || "User"}
                </div>
              </div>
              <button
                className="btn btn-sm border-0 p-2 text-white"
                style={{ opacity: 0.7 }}
                onClick={() => {
                  this.Logout();
                }}
                title={["super_user","admin-company"].includes(user_profile?.user_type) ? t("back_to_portal") : t("logout")}
              >
                <span className="icon">{"\uf08b"}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
